import React, { useState } from 'react';
import useSWR from 'swr';
import fetcher from '../../utils/fetcher';
import Card from '../../components/Card';
import Paging from '../../components/Pagination';
import { Helmet } from 'react-helmet';
import './style.css';
import moment from 'moment';
import 'moment/locale/ko';

const PressRoom = () => {
  const url = 'https://api.testworks.co.kr'
  const { data } = useSWR('https://api.testworks.co.kr/press-releases?_sort=set_day:DESC', fetcher);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = data?.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  }

  if (!data) return null;

  return (
    <>
      <Helmet>
        <title>Press Releases – 에이아이웍스</title>
        <meta name='description' content='에이아이웍스의 뉴스 및 발표와 관련된 기사 및 보도자료를 살펴보세요.' />
      </Helmet>
      <section className='press-room'>
        <section className='visual_wrap'>
          <div className='inner'>
            <div className='tit_wrap'>
              <h2>News</h2>
              <p id='aw_visual_txt1'>에이아이웍스의 뉴스 및 발표와 관련된 기사 및 보도자료를 살펴보세요.</p>
            </div>
          </div>
        </section>
        <div className='inner'>
          <div className='header'>
            <h2>Press Release</h2>
            <div>TOTAL&nbsp;<span>{data.length}</span></div>
          </div>

          {data ? (
            <>
              <div className='list-container'>
                {data && (
                  currentPosts.map((post) => {
                    if (post.showing) {
                      return (
                          <Card
                              key={post.id}
                              id={post.id}
                              to={`/pressdetail/${post.id}`}
                              src={url + post.thumbnail.url}
                              title={post.title}
                              preview={post.preview}
                              date={moment(post.set_day).format('YYYY.MM.DD')}
                          />
                      )} else {
                      return null;
                    }
                  })
                )}
              </div>
              <Paging
                activePage={currentPage}
                itemsCountPerPage={postsPerPage}
                totalItemsCount={data.length}
                onChange={handlePageChange}
              />
            </>
          ) : (
            <div className='loading'>Loading...</div>
          )}
        </div>
      </section>
    </>
  )
}

export default PressRoom;